import {
    GET_REPORT_TITLES,
    GET_USER_DATA,
    SET_FILTER_REPORT_TYPE,
    SET_FILTER_DEPARTMENT,
    SET_FILTER_AREA,
    SET_FILTER_USER_UID,
    SET_SEARCH_DATE_FROM,
    SET_SEARCH_DATE_TO,
    SET_REPORT_FILTER_STATE,
    SET_PAGE,
    SET_ROWS_PER_PAGE,
    SET_REPORT_STATUS,
    SET_SELECTED_ROW,
    SET_REPORT_EDIT_STATUS,
    SET_STATUS_CHANGE_MODAL_INFO,
    DELETE_REPORT,
    SET_DELETE_STATUS,
    SET_FILTER_JOB_ID,
    SET_FILTER_YEAR,
    SET_FILTER_MONTH,
    GET_REPORTS,
    GET_JOB_PACKS,
    GET_JOB_PENDING,
    GET_JOB_ARCHIVED,
    GET_JOBPACKS,
    PARTICULAR_REPORTS,
    GET_JOB_YEARS,
    SET_DAY,
    SET_SORT_TABLE_TYPE,
    SET_SORT_TABLE_KEY,
    SET_SORT_TABLE_AS,
    CLIENT_NAME
} from "./types";
import moment from "moment";
let date = new Date();
let y = moment(date).format("YYYY");
let m = moment(date).format("MMM").toLowerCase();

const INITIAL_STATE = {
    requestingTitles: false,
    requestingStatus: false,
    requestingUserData: false,
    userData: false,
    reportTitles: false,
    fullReports: false,
    particularReports: false,
    job_packs: false,
    job_archived: false,
    job_pending: false,
    job_years: false,
    reportType: "all_reports",
    department: "all_departments",
    area: "all_areas",
    userUid: "all_users",
    dateFrom: false,
    dateTo: false,
    filterState: false,
    rowsPerPage: 50,
    page: 0,
    postingReportStatus: false,
    selectedRow: false,
    postingReportEditStatus: false,
    changeReportStatusModal: {
        state: false,
        status: false,
        uid: false,
        reportType: false,
        timestamp: false,
        type: false,
        subjectName: false,
        subjectChild: false,
    },
    deletedStatus: { deleteSuccess: false, deleteFail: false },
    deletingReport: false,
    jobID: false,

    jobPacks: false,
    year: y,
    month: m,
    day: false,
    sortTableType: "asc",
    sortTableKey: false,
    sortTableAs: false,
    clientName: false,
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_JOB_YEARS.REQUEST: {
            return { ...state, requestingTitles: true, job_years: false };
        }
        case GET_JOB_YEARS.FAIL: {
            return { ...state, requestingTitles: false, job_years: false };
        }
        case GET_JOB_YEARS.SUCCESS: {
            return {
                ...state,
                requestingTitles: false,
                job_years: action.payload,
            };
        }
        case GET_JOB_PACKS.REQUEST: {
            return { ...state, requestingTitles: true, job_packs: false };
        }
        case GET_JOB_PACKS.FAIL: {
            return { ...state, requestingTitles: false, job_packs: false };
        }
        case GET_JOB_PACKS.SUCCESS: {
            return {
                ...state,
                requestingTitles: false,
                job_packs: action.payload,
            };
        }
        case GET_JOB_PENDING.REQUEST: {
            return { ...state, requestingTitles: true, job_pending: false };
        }
        case GET_JOB_PENDING.FAIL: {
            return { ...state, requestingTitles: false, job_pending: false };
        }
        case GET_JOB_PENDING.SUCCESS: {
            return {
                ...state,
                requestingTitles: false,
                job_pending: action.payload,
            };
        }
        case GET_JOB_ARCHIVED.REQUEST: {
            return { ...state, requestingTitles: true, job_archived: false };
        }
        case GET_JOB_ARCHIVED.FAIL: {
            return { ...state, requestingTitles: false, job_archived: false };
        }
        case GET_JOB_ARCHIVED.SUCCESS: {
            return {
                ...state,
                requestingTitles: false,
                job_archived: action.payload,
            };
        }
        case GET_REPORTS.REQUEST: {
            return { ...state, requestingTitles: true, fullReports: false };
        }
        case GET_REPORTS.FAIL: {
            return { ...state, requestingTitles: false, fullReports: false };
        }
        case GET_REPORTS.SUCCESS: {
            return {
                ...state,
                requestingTitles: false,
                fullReports: action.payload,
            };
        }
        case PARTICULAR_REPORTS.REQUEST: {
            return {
                ...state,
                requestingTitles: true,
                particularReports: false,
            };
        }
        case PARTICULAR_REPORTS.FAIL: {
            return {
                ...state,
                requestingTitles: false,
                particularReports: false,
            };
        }
        case PARTICULAR_REPORTS.SUCCESS: {
            return {
                ...state,
                requestingTitles: false,
                particularReports: action.payload,
            };
        }
        case GET_REPORT_TITLES.REQUEST: {
            return { ...state, requestingTitles: true, reportTitles: false };
        }
        case GET_REPORT_TITLES.FAIL: {
            return { ...state, requestingTitles: false, reportTitles: false };
        }
        case GET_REPORT_TITLES.SUCCESS: {
            return {
                ...state,
                requestingTitles: false,
                reportTitles: action.payload,
            };
        }
        case GET_USER_DATA.REQUEST: {
            return { ...state, requestingUserData: true, userData: false };
        }
        case GET_USER_DATA.FAIL: {
            return { ...state, requestingUserData: false, userData: false };
        }
        case GET_USER_DATA.SUCCESS: {
            return {
                ...state,
                requestingUserData: false,
                userData: action.payload,
            };
        }

        case SET_FILTER_REPORT_TYPE: {
            return { ...state, reportType: action.payload };
        }

        case SET_FILTER_USER_UID: {
            return { ...state, userUid: action.payload };
        }
        case SET_SEARCH_DATE_FROM: {
            return { ...state, dateFrom: action.payload };
        }
        case SET_DAY: {
            return { ...state, day: action.payload };
        }
        case CLIENT_NAME: {
            return { ...state, clientName: action.payload };
        }
        case SET_SEARCH_DATE_TO: {
            return { ...state, dateTo: action.payload };
        }
        case SET_REPORT_FILTER_STATE: {
            return { ...state, filterState: action.payload };
        }
        case SET_ROWS_PER_PAGE: {
            return { ...state, rowPerPage: action.payload };
        }
        case SET_PAGE: {
            return { ...state, page: action.payload };
        }
        case SET_REPORT_STATUS.REQUEST: {
            return {
                ...state,
                requestingStatus: true,
                postingReportStatus: true,
            };
        }
        case SET_REPORT_STATUS.FAIL: {
            return {
                ...state,
                requestingStatus: false,
                postingReportStatus: false,
            };
        }
        case SET_REPORT_STATUS.SUCCESS: {
            return {
                ...state,
                requestingStatus: false,
                postingReportStatus: false,
            };
        }
        case SET_SELECTED_ROW: {
            return { ...state, selectedRow: action.payload };
        }
        case SET_REPORT_EDIT_STATUS.REQUEST: {
            return {
                ...state,
                requestingStatus: true,
                postingReportEditStatus: true,
            };
        }
        case SET_REPORT_EDIT_STATUS.FAIL: {
            return {
                ...state,
                requestingStatus: false,
                postingReportEditStatus: false,
            };
        }
        case SET_REPORT_EDIT_STATUS.SUCCESS: {
            return {
                ...state,
                requestingStatus: false,
                postingReportEditStatus: false,
            };
        }
        case SET_STATUS_CHANGE_MODAL_INFO: {
            return { ...state, changeReportStatusModal: action.payload };
        }
        case DELETE_REPORT.REQUEST: {
            return {
                ...state,
                requestingStatus: true,
                deletingReport: true,
                deletedStatus: { deleteSuccess: false, deleteFail: false },
            };
        }
        case DELETE_REPORT.FAIL: {
            return {
                ...state,
                requestingStatus: false,
                deletingReport: false,
                deletedStatus: { deleteSuccess: false, deleteFail: true },
            };
        }
        case GET_JOBPACKS.REQUEST: {
            return {
                ...state,
                requestingStatus: true,
                jobPacks: false,
            };
        }
        case GET_JOBPACKS.FAIL: {
            return {
                ...state,
                requestingStatus: false,
                jobPacks: false,
            };
        }
        case GET_JOBPACKS.SUCCESS: {
            return {
                ...state,
                requestingStatus: false,
                jobPacks: action.payload,
            };
        }
        case DELETE_REPORT.SUCCESS: {
            return {
                ...state,
                deletingReport: false,
                requestingStatus: false,
                deletedStatus: { deleteSuccess: true, deleteFail: false },
            };
        }
        case SET_DELETE_STATUS: {
            return {
                ...state,
                deletedStatus: { deleteSuccess: false, deleteFail: false },
            };
        }
        case SET_FILTER_JOB_ID: {
            return { ...state, jobID: action.payload };
        }
        case SET_FILTER_YEAR: {
            return { ...state, year: action.payload };
        }
        case SET_FILTER_MONTH: {
            return { ...state, month: action.payload };
        }
        case SET_FILTER_DEPARTMENT: {
            return { ...state, department: action.payload };
        }
        case SET_FILTER_AREA: {
            return { ...state, area: action.payload };
        }
        case SET_SORT_TABLE_TYPE: {
            return { ...state, sortTableType: action.payload };
        }
        case SET_SORT_TABLE_KEY: {
            return { ...state, sortTableKey: action.payload };
        }
        case SET_SORT_TABLE_AS: {
            return { ...state, sortTableAs: action.payload };
        }
        default: {
            return state;
        }
    }
};
